module.exports = __webpack_public_path__ + "static/img/my_vulnerability-icon.dd2d3da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/my_vulnerability-icon.png
// module id = IcnB
// module chunks = 2